import{post } from '@/utils/request';
import{oaserver,erpserver,attendanceserver} from '@/utils/baseUrl';

//仓库列表
//获取仓库
export async function getWarehouseList(params) {
    return post(erpserver+'/currency/getWarehouseList', params, true)
}
//公司列表
export async function getCompanyList(params) {
    return post(erpserver+'/currency/getCompanyList', params, true);
}
//公司列表
export async function getGroupList(params) {
    return post(erpserver+'/currency/getGroupList', params, true);
}
//库存管理列表
export async function getlist(params) {
    return post(erpserver+'/inventory/get-list', params, true);
}
//转换库存内外销属性
export async function switchxtype(params) {
    return post(erpserver+'/inventory/switch-xtype', params, true);
}
//库存转移申请列表
export async function switchrequestlist(params) {
    return post(erpserver+'/inventory/switch-request-list', params, true);
}
//获取报表时间
export async function time(params) {
    return post(attendanceserver+'/attendence/kqtc/time', params, true)
}


